import { useState } from "react";
import Dialog from "../shared/Dialog";
import DashboardTab from "./DashboardTab";
import ReportTab from "./ReportTab";
import ShareAffiliateLinkDialog from "./ShareAffiliateLinkDialog";
import UserListTab from "./UserListTab";
import UserProfitLossTab from "./UserProfitLossTab";

const affiliateTabs = [
  { label: "Dashboard", key: "dashboard" },
  { label: "User List", key: "user-list" },
  { label: "Share Affiliate", key: "share", isDialog: true },
  { label: "User Profit/Loss", key: "profit-loss" },
  { label: "Report", key: "report" },
];

const ReferAndEarn = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [shareAffiliateDialog, setShareAffiliateDialog] = useState(false);
  return (
    <>
      <div className="bet-table-header">
        <div className="row align-items-center g-0">
          <div className="col-md-6">
            <span className="list-sport-title"> Affiliate Refer & Earn</span>
          </div>
        </div>
      </div>
      <div className="affiliate-tabs">
        <div className="affiliate-tab-list">
          {affiliateTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`affiliate-tab ${
                activeTab === tab.key ? "active-tab" : ""
              }`}
              onClick={() => {
                if (tab.isDialog) {
                  setShareAffiliateDialog(true);
                  return;
                }
                setActiveTab(tab.key);
              }}
            >
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
      {activeTab === "dashboard" && <DashboardTab />}
      {activeTab === "user-list" && <UserListTab />}
      {activeTab === "profit-loss" && <UserProfitLossTab />}
      {activeTab === "report" && <ReportTab />}

      <Dialog
        show={shareAffiliateDialog}
        onHide={() => setShareAffiliateDialog(false)}
        centered
        animation={false}
        dialogClassName="share-affiliate-dialog"
        contentClassName="mat-dialog-container"
      >
        <ShareAffiliateLinkDialog
          open={shareAffiliateDialog}
          onClose={() => setShareAffiliateDialog(false)}
        />
      </Dialog>
    </>
  );
};

export default ReferAndEarn;
